import React from 'react';
import { useTranslation } from 'react-i18next';
import ProcessStep from './ProcessStep';
import { Upload, FileText, Bot, BarChart3, Rocket } from 'lucide-react';

const HowItWorksSection: React.FC = () => {
  const { t } = useTranslation();
  const steps = t('landing.how_it_works.steps', { returnObjects: true }) as Array<{
    title: string;
    description: string;
  }>;

  const stepIcons = [Upload, FileText, Bot, Rocket];
  const gradients = [
    'from-blue-500 to-cyan-600',
    'from-purple-500 to-pink-600',
    'from-emerald-500 to-teal-600',
    'from-amber-500 to-orange-600'
  ];

  return (
    <section id="how-it-works" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t('landing.how_it_works.title').includes('Comment ça marche') ? (
              <>
                Comment{' '}
                <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                  ça marche
                </span>{' '}
                <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
                  concrètement
                </span>
              </>
            ) : (
              <>
                How{' '}
                <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                  it works
                </span>{' '}
                <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
                  concretely
                </span>
              </>
            )}
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            {t('landing.how_it_works.subtitle').includes('4 étapes simples') ? (
              <>
                Analysez votre compatibilité en{' '}
                <span className="text-cyan-400 font-semibold">4 étapes simples</span>{' '}
                et obtenez une lettre de motivation personnalisée
              </>
            ) : (
              <>
                Analyze your compatibility in{' '}
                <span className="text-cyan-400 font-semibold">4 simple steps</span>{' '}
                and get a personalized cover letter
              </>
            )}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <ProcessStep
              key={index}
              icon={stepIcons[index]}
              title={step.title}
              description={step.description}
              gradient={gradients[index]}
              stepNumber={index + 1}
              delay={index * 150}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;